import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular/standalone';
import { AuthService } from '../../../auth/auth.service';
import { matchPasswords } from '../check-passwords.validator';
import { AsyncPipe } from '@angular/common';
import { addIcons } from "ionicons";
import { informationCircleOutline, lockClosedOutline, alertCircleOutline, close, personCircleOutline, logOutOutline } from "ionicons/icons";
import { IonContent, IonItem, IonIcon, IonLabel, IonInput, IonButton, IonSpinner, IonModal, IonToolbar, IonButtons, IonFooter, IonHeader, IonTitle } from "@ionic/angular/standalone";

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    IonContent,
    IonItem,
    IonIcon,
    IonLabel,
    IonInput,
    IonButton,
    IonSpinner,
    IonModal,
    IonToolbar,
    IonButtons,
    IonHeader,
    IonTitle
  ],
})
export class NewPasswordComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  private fb = inject(UntypedFormBuilder);
  private modalController = inject(ModalController);

  newPasswordForm: UntypedFormGroup;
  errorMessage: string = null;
  currentPassword: string;
  requesting: boolean;
  isConfirmPasswordModalOpen = false;

  get controls() { return this.newPasswordForm.controls; }

  get confirmPassword() { return this.newPasswordForm.get('confirmPassword'); }

  get newPassword() { return this.newPasswordForm.get('newPassword'); }

  constructor() {
    addIcons({ informationCircleOutline, lockClosedOutline, alertCircleOutline, close, personCircleOutline, logOutOutline });
  }

  ngOnInit() {
    this.requesting = false;
    this.initForm();
  }

  initForm() {
    this.newPasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.minLength(6)]
    }, {
      validators: [matchPasswords('newPassword', 'confirmPassword')]
    });
  }

  async confirmCurrentPassword() {
    this.isConfirmPasswordModalOpen = false;
    try {
      await this.auth.reauthenticateUser(this.currentPassword);
      this.confirmNewPassword();
    } catch (error) {
      if (error.code === 'auth/wrong-password') {
        this.errorMessage = `Senha atual incorreta`;
      } else {
        console.error('Error reauthenticating user', error);
        this.errorMessage = `Ocorreu um erro ao atualizar a senha: ${error.code}`;
      }
    } finally {
      this.currentPassword = '';
    }
  }

  async confirmNewPassword() {
    this.errorMessage = null;
    const { newPassword } = this.newPasswordForm.value;
    this.requesting = true;

    try {
      this.errorMessage = '';
      await this.auth.updatePassword(newPassword);
      this.dismiss();
    } catch (error) {
      if (error.code === 'auth/requires-recent-login') {
        this.isConfirmPasswordModalOpen = true;
      } else {
        console.error('Error updating user password', error);
        this.errorMessage = `Ocorreu um erro ao atualizar a senha: ${error.code}`;
      }
    } finally {
      this.requesting = false;
    }
  }

  dismiss() {
    this.modalController.dismiss();
  }

  signOut() {
    this.auth.signOut();
  }
}
